import styled from "styled-components";
import LeftArrow from "@assets/svg/LeftArrow.svg?react";
import CheckFeat from "@assets/svg/CheckFeat.svg?react";
import ArrowRight from "@assets/svg/RightArrow.svg?react";
import { Swiper } from "swiper/react";

// Common Interfaces
export interface StyleProps {
  $isActive: boolean;
  $isRTL?: boolean;
  discriptionType?: string;
}

export interface BreakpointProps {
  $isPhone: boolean;
}

// =============== Page Layout Styles ===============
export const PageContainer = styled.div<BreakpointProps>`
  background: #ffffff;
  margin-inline: ${({ $isPhone }) => ($isPhone ? "16px" : "36px")};
  margin-block: ${({ $isPhone }) => ($isPhone ? "24px" : "145px")};
  display: flex;
  alignitems: center;
  justify-content: center;
  width: 100%;
  margin-top: ${({ $isPhone }) => ($isPhone ? "0" : "50px")};
`;

export const ContentContainer = styled.div<BreakpointProps>`
  min-height: ${({ $isPhone }) => ($isPhone ? "auto" : "200px")};
  background: #ffffff;
  width: 100%;
  border-radius: 16px;
  border: 1px solid #efeff1;
  padding: ${({ $isPhone }) => ($isPhone ? "20px" : "0")};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledArrowRight = styled(ArrowRight)`
  width: 16px;
  height: 16px;
  fill: #62606f;
`;
export const StyledArrowLeft = styled(ArrowRight)`
  width: 16px;
  height: 16px;
  transform: rotate(180deg);
`;
// =============== Toggle Styles ===============
export const ToggleContainer = styled.div<BreakpointProps>`
  margin-bottom: ${({ $isPhone }) => ($isPhone ? "24px" : "0")};
  margin-top: 24px;
`;
export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ToggleWrapper = styled.span<BreakpointProps>`
  display: flex;
  align-items: center;
  gap: 4px;
  justify-content: center;
  width: ${({ $isPhone }) => ($isPhone ? "250px" : "322px")};
  height: 42px;
  background: #f3f3f3;
  border-radius: 8px;
  padding-inline: 4px;
`;

export const ToggleOption = styled.span<StyleProps>`
  cursor: pointer;
  width: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 68px;
  height: 34px;
  padding: 8px;
  background: ${({ $isActive }) => ($isActive ? "#FFFFFF" : "#F3F3F3")};
  color: ${({ $isActive }) => ($isActive ? "#5B3FFF" : "inherit")};
  font-size: 14px;
  border-radius: 4px;
  box-shadow:
    0px 2px 3px 0px #0000000a,
    0px 24px 68px 0px #2f30370d,
    0px 4px 6px 0px #222a350a,
    0px 1px 1px 0px #0000000d;
  font-weight: ${({ $isActive }) => ($isActive ? 700 : 400)};
`;

export const DiscountBadge = styled.span`
  width:fit-content;
  height:18px
  font-weight: 400;
  font-size: 10px;
  color: #16ae26;
  background: #E6F4EA;
  display:flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
`;
export const Divider = styled.span`
  border-bottom: 1px solid #efeff1;
  margin-block: 20px;
  width: 93%;
  display: block;
  padding-inline: 10px;
`;
export const StyledLeftArrow = styled(LeftArrow)`
  width: 16px;
  height: 16px;
  fill: #62606f;
`;
export const StyledRightArrow = styled(LeftArrow)`
  width: 16px;
  height: 16px;
  fill: #62606f;
  transform: rotate(180deg);
`;
// Container for the subscription card
export const SubscriptionCard = styled.div<BreakpointProps>`
  width: ${({ $isPhone }) => ($isPhone ? "100%" : "648px")};
  padding-bottom: 24px;
  height: fit-content;
  border-radius: 24px;
  border: 1px solid #efeff1;
  margin-block: ${({ $isPhone }) => ($isPhone ? "20px" : "40px")};
  margin-inline: ${({ $isPhone }) => ($isPhone ? "0" : "20px")};
  background: #fff;
  display: flex;
  flex-direction: column;
`;

// Wrapper for the order summary section
export const OrderSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-inline: 24px;
  padding-top: 24px;
  padding-bottom: 8px;
  gap: 8px;
`;

// Title and "change package" section
export const TitleRow = styled.span<{ $isPhone: boolean }>`
  display: flex;
  flex-direction: ${({ $isPhone }) => ($isPhone ? "column" : "row")};
  align-items: ${({ $isPhone }) => ($isPhone ? "flex-start" : "center")};
  justify-content: space-between;
  gap: ${({ $isPhone }) => ($isPhone ? "4px" : "0")};
`;

export const PackageTitle = styled.span`
  font-weight: 700;
  font-size: 22px;
`;

export const ChangeLink = styled.span`
  font-weight: 400;
  font-size: 22px;
  color: #5b3fff;
  cursor: pointer;
`;

export const RenewalNote = styled.span`
  font-weight: 400;
  font-size: 16px;
  color: #62606f;
`;

// Invitation Code Section
export const InvitationCodeSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 24px;
`;

export const InvitationCodeQuestion = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: #5b3fff;
  cursor: pointer;
  padding-inline: 24px;
  transition: color 0.2s ease;

  &:hover {
    color: #4a2fd9;
  }
`;

export const InvitationCodeInput = styled.input`
  height: 52px;
  padding: 12px 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  margin-inline: 24px;
  width: calc(100% - 48px);
  transition: all 0.2s ease;
  background-color: #ffffff;

  &::placeholder {
    color: #9e9e9e;
  }

  &:focus {
    border-color: #5b3fff;
    box-shadow: 0 0 0 2px rgba(91, 63, 255, 0.1);
  }

  &:hover {
    border-color: #b8b8b8;
  }
`;

export const InvitationCodeError = styled.div<{ $isRTL: boolean }>`
  color: #ff4444;
  font-size: 12px;
  margin-top: 5px;
  margin-inline: 20px;
  text-align: ${({ $isRTL }) => ($isRTL ? "right" : "left")};
`;

// Summary heading
export const SummaryHeading = styled.span`
  display: flex;
  font-weight: 700;
  font-size: 22px;
  justify-content: flex-start;
  width: 100%;
  padding-inline: 24px;
`;

// Summary info container
export const SummaryInfo = styled.span`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const PropertiesSection = styled.div<BreakpointProps>`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-between;
  width: 100%;
  padding-inline: 24px;

  & > span:first-child {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  & > span:nth-child(2) {
    font-weight: 400;
    font-size: 10px;
    color: #625783;
    text-align: start;
    width: ${({ $isPhone }) => ($isPhone ? "100%" : "260px")};
  }
`;

export const SummaryRow = styled.span`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-inline: 24px;
`;

export const TotalRow = styled(SummaryRow)`
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  font-weight: 500;
`;

// Subscribe button
export const SubscribeButtonWrapper = styled.div`
  padding-inline: 24px;
  margin-top: 16px;
`;

export const SubscribeButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-inline: 20px;
  width: 100%;
  height: 41px;
  border-radius: 9999px;
  border: none;
  background: #5b3fff;
  color: white;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
`;

// Footer note
export const FooterNote = styled.div`
  width: 100%;
  padding-inline: 24px;
  margin-top: 7px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 12px;
  text-align: center;
`;
